import { FETCH_ROLE, GET_ROLE, CREATE_ROLE, UPDATE_ROLE, DELETE_ROLE, GET_ROLE_BY_NAME } from 'actions/role';
import * as _ from 'lodash';
import { toast } from 'react-toastify';

const initialState = {
  isLoading: false,
  roles: [],
  roleDetail: {},
  roleByName: {},
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const roleReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_ROLE.REQUEST:
    case GET_ROLE.REQUEST:
    case CREATE_ROLE.REQUEST:
    case DELETE_ROLE.REQUEST: {
      return { ...state, isLoading: true, roleDetail: {} };
    }

    case GET_ROLE_BY_NAME.REQUEST:
    case UPDATE_ROLE.REQUEST: {
      return { ...state, isLoading: true };
    }

    case FETCH_ROLE.SUCCESS: {
      if (payload.page === 1) {
        return {
          ...state,
          isLoading: false,
          roles: payload.results,
          page: payload.page,
          limit: payload.limit,
          totalPages: payload.totalPages,
          total: payload.totalResults,
        };
      } else {
        return {
          ...state,
          isLoading: false,
          roles: _.concat(state.roles, payload.results),
          page: payload.page,
          limit: payload.limit,
          totalPages: payload.totalPages,
          total: payload.totalResults,
        };
      }
    }

    case GET_ROLE_BY_NAME.SUCCESS: {
      return {
        ...state,
        roleByName: payload.results?.[0] ?? {},
        isLoading: false,
      };
    }

    case GET_ROLE.SUCCESS: {
      return {
        ...state,
        roleDetail: payload,
        isLoading: false,
      };
    }

    case CREATE_ROLE.SUCCESS: {
      toast.success('Role added successfully');
      return {
        ...state,
        roles: _.concat(state.roles, payload),
        isLoading: false,
      };
    }

    case UPDATE_ROLE.SUCCESS: {
      toast.success('Role updated successfully');
      return {
        ...state,
        isLoading: false,
        roles: state.roles.map((data) => {
          if (data.id === payload.id) {
            return payload;
          } else {
            return data;
          }
        }),
      };
    }

    case DELETE_ROLE.SUCCESS: {
      toast.success('Role deleted successfully');
      return {
        ...state,
        isLoading: false,
        roles: state.roles.filter((data) => data.id !== payload),
      };
    }

    case FETCH_ROLE.FAIL:
    case GET_ROLE.FAIL:
    case GET_ROLE_BY_NAME.FAIL:
    case CREATE_ROLE.FAIL:
    case UPDATE_ROLE.FAIL:
    case DELETE_ROLE.FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }
    default:
      return {
        ...state,
      };
  }
};
export default roleReducer;
